var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReporting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6294 4.58333H14.5833V0.537167L18.6294 4.58333ZM19.1666 6.41667V22H0.833252V2.75C0.833252 1.23108 2.06434 0 3.58325 0H12.7499V6.41667H19.1666ZM7.24992 14.6667H5.41659V18.3333H7.24992V14.6667ZM10.9166 10.0833H9.08325V18.3333H10.9166V10.0833ZM14.5833 12.8333H12.7499V18.3333H14.5833V12.8333Z",
    fill: "#6F767E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReporting);
export default __webpack_public_path__ + "static/media/reporting.daeea1c9294fb067f1d5771c87f44611.svg";
export { ForwardRef as ReactComponent };